import HttpService from "common/http/httpService";
import { MarketStatus } from "./marketStatus";

class MarketScheduleService extends HttpService {

    async listSchedule(commodityId: number): Promise<MarketScheduleItem[]> {
        const response = await this.getClient().get<MarketScheduleItem[]>(`/offers/v1/market-schedule/${commodityId}`);
        return response.data;
    }

    async listHolidays(commodityId: number): Promise<MarketHoliday[]> {
        const response = await this.getClient().get<MarketHoliday[]>(`/offers/v1/market-schedule/${commodityId}/holidays`);
        return response.data;
    }
}

export interface MarketScheduleItem {
    status: MarketStatus;
    dayOfWeek: number;
    startTime: string;
    endTime: string;
}

export interface MarketHoliday {
    status: MarketStatus;
    startDate: Date;
    endDate: Date;
}

const marketScheduleService = new MarketScheduleService();
export default marketScheduleService;